import UnAuhtorized from '../components/common/un-auhorized/UnAuthorized';
import { useAuthStatus } from '../hooks/UseAuthStatus';
import { Route } from "react-router-dom";
import Loader from './../components/common/loader/Loader';

const ProtectedRoute = ( props ) => {
  
    const { loggedIn, checkingStatus } = useAuthStatus();
    
    return (
     <>
        { 
            checkingStatus 
            ? <Loader show={true} /> 
            : loggedIn ? <Route { ...props } /> : <UnAuhtorized/> 
        }
     </>

    );

};
export default ProtectedRoute;